import React, { useContext, useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./Your_Details.css";
import Prev_Btn from "../../../../common/common-btn/prev-btn/Prev_Btn";
import Next_Btn from "../../../../common/common-btn/next-btn/Next_Btn";
import { useForm } from "react-hook-form";
import { Context } from "../../../../../utils/context";

const Your_Details = ({ setActiveTab, setIsReviewMode }) => {

  const {
    register,
    handleSubmit,
    control, reset,
    formState: { errors },
  } = useForm();

  const {
    IMG_URL,
    Select2Data,
    getData,
    postData,
    BookingData,
    setBookingData
  } = useContext(Context);
  const [phone, setPhone] = useState("");
  const handleBack = () => {
    setActiveTab("pickup");
  };

  const handleBook = () => {
    setIsReviewMode(true);
  };



  const onSubmit = async (data) => {
    console.log("Form Data:", data);
    const formData = new FormData();

    formData.append("contact_no", data?.contact_no);
    formData.append("email", data?.email);
    formData.append("first_name", data?.first_name);
    formData.append("last_name", data?.last_name);

    const response = await postData(`/without-login/booking/step-2/${BookingData?.id}`, formData);
    if (response?.success) {
      // setTimeout(() => {
      await handleBook()
      // }, 2500);
    } else {
      // setApiError(response?.errors)
      console.error("Form submission failed:", response?.errors);
    }
  };

  const resetFormData = async () => {
    await reset({
      contact_no: BookingData?.user?.contact_no,
      email: BookingData?.user?.email || "",
      first_name: BookingData?.user?.first_name || "",
      last_name: BookingData?.user?.last_name || "",
    })
  }

  useEffect(() => {
    resetFormData()
  }, [BookingData]);
  return (
    <section className="Your_Details Your_Booking_Conditions">
      <div className="booking_card">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <h6 className="booking_headings">Your Details</h6>

            <div className="booking_form">
              <div className="row  align-items-center info_row ">
                <div className="col-lg-3 col-5">
                  <Form.Label className="info_label">Full Name</Form.Label>
                </div>

                <div className="col-lg-1 col-1">:</div>
                <div className="col-lg-8">
                  <div className="row">
                    <div className="col">
                      <Form.Control
                        type="text"
                        placeholder="Enter First Name"
                        className="booking_input"
                        {...register("first_name", {
                          required: "First name is required",
                          minLength: {
                            value: 3,
                            message: "First Name must be at least 3 characters",
                          },
                          maxLength: {
                            value: 50,
                            message: "First Name cannot exceed 50 characters",
                          },
                          pattern: {
                            value: /^[A-Za-z\s]+$/,
                            message: "First Name can only contain letters and spaces",
                          },
                        })}
                      />
                      {errors?.first_name && (
                        <span className="text-danger">
                          {errors.first_name.message}
                        </span>
                      )}
                    </div>

                    <div className="col">
                      <Form.Control
                        type="text"
                        placeholder="Enter Last Name"
                        className="booking_input"
                        {...register("last_name", {
                          required: "Last name is required",
                          minLength: {
                            value: 3,
                            message: "Last Name must be at least 3 characters",
                          },
                          maxLength: {
                            value: 50,
                            message: "Last Name cannot exceed 50 characters",
                          },
                          pattern: {
                            value: /^[A-Za-z\s]+$/,
                            message: "Last Name can only contain letters and spaces",
                          },
                        })}
                      />
                      {errors?.last_name && (
                        <span className="text-danger">
                          {errors.last_name.message}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row  align-items-center info_row ">
                <div className="col-lg-3 col-6">
                  <Form.Label className="info_label">
                    {" "}
                    Contact Number
                  </Form.Label>
                </div>
                <div className="col-lg-1 col-1">:</div>
                <div className="col-lg-8 col-12">
                  <Form.Control
                    placeholder="Contact Number"
                    type="text"
                    name="contact_no"
                    maxLength={10} // restrict typing to 10 digits
                    {...register("contact_no", {
                      required: "Contact Number is required",
                      pattern: {
                        value: /^[0-9]+$/,  // only numbers
                        message: "Only digits are allowed",
                      },
                      minLength: {
                        value: 10,
                        message: "Contact Number must be exactly 10 digits",
                      },
                      maxLength: {
                        value: 10,
                        message: "Contact Number must be exactly 10 digits",
                      },
                    })}
                  />
                  {errors?.contact_no && (
                    <span className="text-danger">
                      {errors.contact_no.message}
                    </span>
                  )}
                </div>
              </div>

              <div className="row  align-items-center info_row ">
                <div className="col-lg-3 col-6">
                  <Form.Label className="info_label"> Email Address</Form.Label>
                </div>

                <div className="col-lg-1 col-1">:</div>

                <div className="col-lg-8">
                  <Form.Control
                    type="email"
                    placeholder="Enter Email"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
                        message: "Enter a valid email address",
                      },
                    })}
                  />
                  {errors?.email && (
                    <span className="text-danger">
                      {errors.email.message}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="both_btn_holder">
        <div onClick={handleBack}>
          <Prev_Btn text="Back" />
        </div>

        <div onClick={handleSubmit(onSubmit)}>
          {/* <div onClick={handleBook}> */}
          <Next_Btn text="Book" />
        </div>
      </div>
    </section>
  );
};

export default Your_Details;
